module.exports = require("./sw-KE.d.ts");